import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { APIService } from "src/app/api/api.service";

@Component({
  selector: "app-launch-ec2-pricing-step",
  templateUrl: "./launch-ec2-pricing.component.html",
  styleUrls: ["../../launch-ec2.operations.component.css"],
})
export class LaunchEc2PricingStepComponent implements OnChanges {
  @Input() apiBaseUrl: string = "";
  @Input() instanceType: string = "";
  @Input() region: string = "";
  @Input() operatingSystem: string = "";
  @Input() requestPayload: any = null;

  loading: boolean = false;
  saving: boolean = false;
  pricing: any = null;
  pricingError: string = "";
  saveSuccessMessage: string = "";
  saveRequestId: string = "";
  saveError: string = "";

  constructor(private apiServer: APIService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["apiBaseUrl"] ||
      changes["instanceType"] ||
      changes["region"] ||
      changes["operatingSystem"]
    ) {
      this.loadPricing();
    }
  }

  private headers() {
    return { Authorization: localStorage.getItem("t") };
  }

  private async post(url: string, body: any) {
    try {
      const r = await this.apiServer.postDataPromis(url, body, this.headers());
      if (typeof r == "string") return null;
      return r;
    } catch {
      return null;
    }
  }

  private getApiErrorMessage(response: any): string {
    if (!response) return "";
    if (typeof response == "string") return response;

    if (Array.isArray(response.detail) && response.detail.length > 0) {
      return response.detail
        .map((x: any) => x?.msg || x?.message || JSON.stringify(x))
        .join(", ");
    }

    if (Array.isArray(response.errors) && response.errors.length > 0) {
      return response.errors.map((x: any) => x?.message || x?.msg || x).join(", ");
    }

    const directMessage =
      response.error ||
      response.error_message ||
      response.message ||
      response.msg;
    if (directMessage) return directMessage.toString();

    return "";
  }

  async loadPricing() {
    this.pricing = null;
    this.pricingError = "";
    this.saveSuccessMessage = "";
    this.saveRequestId = "";
    this.saveError = "";

    if (!this.instanceType || !this.operatingSystem || !this.region) {
      this.pricingError = "Instance Type, Operating System, and Region are required for pricing.";
      return;
    }

    this.loading = true;
    const url = `${this.apiBaseUrl}/admin/apis/create_ec2_instance/api/ec2/pricing`;
    const payload = {
      instance_type: this.instanceType,
      region: this.region,
      operating_system: this.operatingSystem,
    };

    const r = await this.post(url, payload);
    const apiError = this.getApiErrorMessage(r);
    if (apiError) {
      this.pricingError = apiError;
      this.loading = false;
      return;
    }

    if (
      r &&
      r.hourly_cost_usd !== undefined &&
      r.monthly_cost_usd !== undefined &&
      r.currency
    ) {
      this.pricing = r;
    } else {
      this.pricingError = "Unable to fetch pricing right now.";
    }
    this.loading = false;
  }

  async saveRequest() {
    this.saveSuccessMessage = "";
    this.saveRequestId = "";
    this.saveError = "";

    if (!this.requestPayload?.request_payload) {
      this.saveError = "Request payload is missing.";
      return;
    }

    this.saving = true;
    const url = `${this.apiBaseUrl}/admin/apis/create_ec2_instance/api/ec2/save-request`;
    const r = await this.post(url, this.requestPayload);

    if (r?.request_id || r?.execution_arn || r?.accountid_region) {
      this.saveRequestId = r?.request_id || "";
      this.saveSuccessMessage = r?.message || "Request saved successfully.";
      this.saving = false;
      return;
    }

    const apiError = this.getApiErrorMessage(r);
    if (apiError) {
      this.saveError = apiError;
      this.saving = false;
      return;
    }

    if (r?.request_id || r?.message) {
      this.saveRequestId = r?.request_id || "";
      this.saveSuccessMessage = r?.message || "Request saved successfully.";
    } else {
      this.saveError = "Save request failed. Please try again.";
    }
    this.saving = false;
  }
}
